import { ComponentType, memo } from 'react';

import {
  AnnouncementsWidget,
  ApprovalWidget,
  MyAbsencesWidget,
  MyCompensationWidget,
  MyDataWidget,
  MyNotificationsWidget,
  MyPerformanceWidget,
  MyTasksWidget,
  MyTeamAbsencesWidget,
  MyTeamWidget,
  MyTeamWorklistsWidget,
  MyWorklistsWidget,
  QuickLinksWidget,
  /* Temporarily commented out: see ticket https://github.com/Solaforce/internal/issues/4212 */
  // SolaIntelWidget,
  TeamAbsencesTodayWidget,
  TeamAnniversariesWidget,
  TeamCompensationWidget,
  TeamPerformanceWidget,
  TeamTasksWidget,
  TeamTimeManagementWidget,
  TeamTrainingsWidget,
} from '../';

import { MyWorkspaceWidgetNames, WidgetProps } from './widgets';

export type WidgetsMap = {
  [key in MyWorkspaceWidgetNames]: {
    title: string;
    component: ComponentType<WidgetProps<object>>;
  };
};

export const myWorkspaceWidgetsMap: WidgetsMap = {
  [MyWorkspaceWidgetNames.AnnouncementsWidget]: {
    title: 'announcements',
    component: memo(AnnouncementsWidget),
  },
  [MyWorkspaceWidgetNames.MyTeamWidget]: {
    title: 'myTeam',
    component: memo(MyTeamWidget),
  },
  [MyWorkspaceWidgetNames.ApprovalWidget]: {
    title: 'Approval Widget',
    component: memo(ApprovalWidget),
  },
  [MyWorkspaceWidgetNames.TeamAbsencesTodayWidget]: {
    title: 'teamAbsencesToday',
    component: memo(TeamAbsencesTodayWidget),
  },
  [MyWorkspaceWidgetNames.TeamCompensationWidget]: {
    title: 'teamCompensation',
    component: memo(TeamCompensationWidget),
  },
  [MyWorkspaceWidgetNames.TeamPerformanceWidget]: {
    title: 'teamPerformance',
    component: memo(TeamPerformanceWidget),
  },
  [MyWorkspaceWidgetNames.MyTeamAbsencesWidget]: {
    title: 'myTeamAbsences',
    component: memo(MyTeamAbsencesWidget),
  },
  [MyWorkspaceWidgetNames.TeamTimeManagementWidget]: {
    title: 'teamTimeManagement',
    component: memo(TeamTimeManagementWidget),
  },
  [MyWorkspaceWidgetNames.TeamTrainingsWidget]: {
    title: 'teamTrainings',
    component: memo(TeamTrainingsWidget),
  },
  [MyWorkspaceWidgetNames.TeamTasksWidget]: {
    title: 'teamTasks',
    component: memo(TeamTasksWidget),
  },
  [MyWorkspaceWidgetNames.TeamAnniversariesWidget]: {
    title: 'teamAnniversaries',
    component: memo(TeamAnniversariesWidget),
  },
  [MyWorkspaceWidgetNames.MyDataWidget]: {
    title: 'myData',
    component: memo(MyDataWidget),
  },
  [MyWorkspaceWidgetNames.MyAbsencesWidget]: {
    title: 'myAbsences',
    component: memo(MyAbsencesWidget),
  },
  [MyWorkspaceWidgetNames.MyCompensationWidget]: {
    title: 'myCompensation',
    component: memo(MyCompensationWidget),
  },
  [MyWorkspaceWidgetNames.MyPerformanceWidget]: {
    title: 'myPerformance',
    component: memo(MyPerformanceWidget),
  },
  [MyWorkspaceWidgetNames.MyNotificationsWidget]: {
    title: 'myNotifications',
    component: memo(MyNotificationsWidget),
  },
  [MyWorkspaceWidgetNames.MyTasksWidget]: {
    title: 'myTasks',
    component: memo(MyTasksWidget),
  },
  [MyWorkspaceWidgetNames.QuickLinksWidget]: {
    title: 'quickLinks',
    component: memo(QuickLinksWidget),
  },
  [MyWorkspaceWidgetNames.MyWorklistsWidget]: {
    title: 'myTasklists',
    component: memo(MyWorklistsWidget),
  },
  [MyWorkspaceWidgetNames.MyTeamWorklistsWidget]: {
    title: 'teamTasklists',
    component: memo(MyTeamWorklistsWidget),
  },
  /* Temporarily commented out: see ticket https://github.com/Solaforce/internal/issues/4212 */
  // [MyWorkspaceWidgetNames.SolaIntelWidget]: {
  //   title: 'solaIntel',
  //   component: memo(SolaIntelWidget),
  // },
};
